import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { HttpService, NotificationService } from '../../../tms-shared';
import { TmsWebBaseEditCreateService } from '../base';
import { PickingListLabel, SalesOrderStockAllocation, StockItemAllocation } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class SalesOrderStockAllocationService extends TmsWebBaseEditCreateService<
  SalesOrderStockAllocation,
  SalesOrderStockAllocation
> {
  public refreshDetails = new Subject<void>();

  constructor(
    protected httpService: HttpService,
    protected notificationService: NotificationService,
  ) {
    super('SalesOrderStockAllocation', $localize`Sales Order Stock Allocation`, httpService, notificationService);
  }

  allocate(
    salesOrderLineId: string,
    stockItemId: string,
    hardAllocation: boolean,
    printPickingList: boolean,
  ): Observable<any> {
    return this.httpService.post<any>(`${this.apiUrl}/Allocate`, {
      salesOrderLineId,
      stockItemId,
      hardAllocation,
      printPickingList,
    });
  }

  swapStockAllocations(stockNo: string, selectedOrders: StockItemAllocation[]): Observable<any> {
    return this.httpService.post<any>(`${this.apiUrl}/SwapStockAllocations`, {
      stockNo,
      selectedOrders,
    });
  }

  updateSalesOrderStockAllocation(salesOrderStockAllocationId: string, quantity: number, focQuantity: boolean) {
    return this.httpService.post<any>(`${this.apiUrl}/UpdateSalesOrderStockAllocation`, {
      salesOrderStockAllocationId,
      quantity,
      focQuantity,
    });
  }

  updateHardAllocation(salesOrderStockAllocationId: string, hardAllocation: boolean) {
    return this.httpService.post<any>(`${this.apiUrl}/UpdateHardAllocation`, {
      salesOrderStockAllocationId,
      hardAllocation,
    });
  }

  getAllocations(salesOrderLineId: any): Observable<SalesOrderStockAllocation[]> {
    return this.httpService.get<SalesOrderStockAllocation[]>(
      `${this.apiUrl}/GetAllocations?salesOrderLineId=${salesOrderLineId}`,
    );
  }

  getPickingListLabel(salesOrderStockAllocationId: any, previousLocation: boolean): Observable<PickingListLabel> {
    return this.httpService.get<PickingListLabel>(
      `${this.apiUrl}/GetPickingListLabel?salesOrderStockAllocationId=${salesOrderStockAllocationId}&previousLocation=${previousLocation}`,
    );
  }

  pick(salesOrderStockAllocationId: string) {
    return this.httpService.post<PickingListLabel>(`${this.apiUrl}/Pick`, {
      salesOrderStockAllocationId,
    });
  }

  multiPick(ids: string[]): Observable<SalesOrderStockAllocation[]> {
    return this.httpService.post<SalesOrderStockAllocation[]>(`${this.apiUrl}/MultiPick`, {
      ids,
    });
  }

  unpick(salesOrderStockAllocationId: string, mergeStock: boolean) {
    return this.httpService.post<any>(`${this.apiUrl}/Unpick`, {
      salesOrderStockAllocationId,
      mergeStock,
    });
  }

  updatePicked(salesOrderStockAllocationId: string, nettQuantity: number) {
    return this.httpService.post<PickingListLabel>(`${this.apiUrl}/UpdatePicked`, {
      salesOrderStockAllocationId,
      nettQuantity,
    });
  }
}
